import { TopBar, TopBarInfo } from '@statsbomb/kitbag-components';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTheme } from 'styled-components';
import { Logo, LogoText } from '../../components/Logo/Logo';
import { Navigation } from '../../containers/Navigation/Navigation';
import {
  NavContainer,
  PageContainer,
  PageSection,
} from './PageWithNavigation.styles';

const displayNavigation = ({ pathname }) =>
  !['/healthz', '/embed', '/token'].find((value) => pathname.includes(value));

export function PageWithNavigation({ children }) {
  const location = useLocation();

  const shouldDisplayNavigation = displayNavigation(location);

  const theme = useTheme();
  const isTouch = !theme.mqMatch(theme.mqFrom('md'));

  return (
    <PageContainer $isTouch={isTouch}>
      {shouldDisplayNavigation && (
        <NavContainer>
          {isTouch ? (
            <TopBar>
              <Navigation />
              <TopBarInfo isTouch={isTouch}>
                <Logo />
                <LogoText />
              </TopBarInfo>
            </TopBar>
          ) : (
            <Navigation />
          )}
        </NavContainer>
      )}
      <PageSection>{children}</PageSection>
    </PageContainer>
  );
}
PageWithNavigation.propTypes = {
  children: PropTypes.node.isRequired,
};

export default { PageWithNavigation };
